import { SerialTicketActions } from '../actions'
import { handleError } from '../handle-error'
import type { SerialTicketProps, TypeOption } from '../modules/serial-ticket/serial-ticket'
import { Storage } from '../storage'
import type { SerialTicketView } from '../types'
import { formatPrice } from '../utils/format-price'
import { getSerialTicketPaymentSection } from './payment-section'

export const getSerialTicketProps = (view: SerialTicketView): SerialTicketProps | undefined => {
    const { state, update } = view
    const { lang, data, validationErrors } = state

    if (!data) {
        return undefined
    }

    const { labels, paymentFailed } = data

    const props: SerialTicketProps = {
        theme: state.theme,
        isLoading: state.isLoading,
        title: labels.title,
        note: labels.note,
        typeLabel: lang.serialTicket_type_label,
        typeOptions: data.types.map(
            (type): TypeOption => ({
                radio: {
                    id: String(type.id),
                    isChecked: state.typeId === type.id,
                    onClick: () => {
                        state.typeId = type.id
                        update()
                    },
                },
                label: {
                    name: type.name,
                    expiration: lang.serialTicket_type_expires.replace('{date}', type.expiration),
                    description: type.description,
                    price: formatPrice(type.price),
                },
            }),
        ),
        email: {
            input: {
                id: 'email',
                label: lang.serialTicket_email_label,
                value: state.email,
                onChange: (value) => {
                    state.email = value
                    update()
                },
                error: validationErrors.email ? lang.contact_email_invalid : undefined,
            },
        },
        submit: {
            text: lang.submit_pay,
            onClick: async () => {
                try {
                    await SerialTicketActions.submit(view)
                } catch (error) {
                    handleError(view, error as Error)
                }
            },
        },
    }

    if (state.data) {
        if (state.data.paymentOptions.length > 1) {
            props.paymentSection = getSerialTicketPaymentSection(view)
        } else {
            Storage.update({ selectedPaymentGateway: state.data.paymentOptions[0].name })
        }
    }

    if (paymentFailed) {
        props.error = {
            title: lang.error_title,
            message: lang.banks_paymentFailed,
        }
    }

    return props
}
